export const OUTAGE_OPTIONS = [
  'Supply Constraint',
  'Allocation',
  'Planned Maintenance',
  'Unplanned Maintenance',
];

export const TIME_RANGE_OPTIONS = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'Upcoming', value: 'upcoming' },
];

export const INITIAL_FILTERS_STATE = {
  outageCategory: [],
  timeRange: { label: 'This Week', value: 'week' },
};
